import { Injectable, Signal, computed } from '@angular/core';
import { IAmountData, IAmountModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { AmountActions, AmountSelectors, IAmountState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class AmountStore extends StateAccessService<IAmountState> {
  readonly state$: Observable<IAmountState>;

  readonly data$$: Signal<IAmountData>;
  readonly model$$: Signal<IAmountModel>;

  minLoanAmount$$ = computed<number>(() => {
    return this.data$$().minLoanAmount;
  });
  maxLoanAmount$$ = computed<number>(() => {
    return this.data$$().maxLoanAmount;
  });

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(AmountSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(AmountSelectors.data);
  }

  dispatchAmountReset() {
    this.stateFacade.dispatch(AmountActions.reset());
  }
  dispatchAmountSubmit() {
    this.stateFacade.dispatch(AmountActions.submit());
  }
  dispatchAmountSubmitSuccess({ model }: { model: IAmountModel }) {
    this.stateFacade.dispatch(AmountActions.submitSuccess({ model }));
  }
  dispatchAmountLoad() {
    this.stateFacade.dispatch(AmountActions.load());
  }
  dispatchAmountLoadSuccess({ model, data }: { model: IAmountModel; data: IAmountData }) {
    this.stateFacade.dispatch(AmountActions.loadSuccess({ model, data }));
  }
}
